import { Checkbox } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import React from "react";

import { OutputsItemViewModel } from "../Output";

interface IProps {
    issueChecked: boolean;
    toggleIssue: () => void;
}

export const OutputIssueCheckboxView: React.FC<IProps> = observer((props) => {
    /**
     * This is required should you host this component on a table row
     * that is clickable.
     */
    const onLinkClick = (event: any) => {
        event.stopPropagation();
        props.toggleIssue();
    };

    return <Checkbox checked={props.issueChecked} onClick={onLinkClick} />;
});
